import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../utils/api";
import AddUser from "../components/AddUser";
import UserList from "../components/UserList";
import toast from "react-hot-toast";
export default function Dashboard() {
    //darkMode
    const [darkMode, setDarkMode] = useState(false);
    //  navigation
    const navigate = useNavigate();

    //  state
    const [users, setUsers] = useState([]);
    const [search, setSearch] = useState("");

    //  تحميل البيانات من API
    useEffect(() => {
        api
            .get("/users")
            .then((res)=>{setUsers(res.data.slice(0, 5));})
            .catch((err) => {
                console.log(err);
            });
    }, []);
    ///darkMode
    useEffect(() => {
        if (darkMode) {
            document.documentElement.classList.add("dark");
        } else {
            document.documentElement.classList.remove("dark");
        }
    }, [darkMode]);
    ///
    //  إضافة مستخدم
    const addUser = (name) => {
        const newUser = {
            id: Date.now(),
            name,
        };
        setUsers([...users, newUser]);
        toast.success("User added successfully ");
    };

    // حذف مستخدم
    const deleteUser = (id) => {
        const confirmDelete = window.confirm("Are you sure?");
        if (!confirmDelete) return;

        setUsers(users.filter((user) => user.id !== id));
        toast.success("The user has been deleted");
    };

    //  تعديل مستخدم
    const updateUser = (id, newName) => {
        setUsers(
            users.map((user) => (user.id === id ? { ...user, name: newName } : user)),
        );
        toast.success("User updated ");
    };

    //  البحث
    const filteredUsers = users.filter((user) =>
        user.name.toLowerCase().includes(search.toLowerCase()),
    );

    //  تسجيل الخروج
    const handleLogout = () => {
        localStorage.removeItem("token");
        navigate("/login");
    };

    return (
        <div className="min-h-screen bg-gray-100  dark:bg-gray-900 p-6">
            <div className="max-w-md mx-auto bg-white dark:bg-gray-800  p-6 rounded shadow">
                <button
                    onClick={() => setDarkMode(!darkMode)}
                    className="mr-4 mb-4 px-2 py-2 rounded-full transition bg-gray-800 text-white hover:bg-gray-700 dark:bg-yellow-400 dark:text-black dark:hover:bg-yellow-300"
                >
                    {darkMode ? "☀️Light " : "🌙Dark "}
                </button>
                {/* زر تسجيل الخروج */}
                <button
                    onClick={handleLogout}
                    className="mb-4 bg-red-500 hover:bg-red-600 text-white px-2 py-2 rounded-full transition"
                >
                    Logout
                </button>

                <h2 className="text-xl font-bold text-center dark:text-white mb-4">
                    User Dashboard
                </h2>

                {/*  البحث */}
                <input
                    className="w-full border p-2 mb-4 rounded dark:bg-gray-700 dark:text-white"
                    placeholder="Search..."
                    onChange={(e) => setSearch(e.target.value)}
                />

                {/*  إضافة مستخدم */}
                <AddUser onAdd={addUser} />

                {/*  عرض المستخدمين */}
                <UserList
                    users={filteredUsers}
                    onDelete={deleteUser}
                    onUpdate={updateUser}
                />
            </div>
        </div>
    );
}
